export default "__VITE_ASSET__DQAGYqCk__"